<template>
  <div class="comment-form">
    <el-form :model="ruleForm" ref="ruleForm" label-width="40px" class="demo-ruleForm">
      <el-input type="textarea" v-model="ruleForm.content" :rows="5" :placeholder="this.$t('common.toSay')"></el-input>
      <div style="margin-top: 15px;">
        <el-button type="success" @click="submitForm('ruleForm')">{{this.$t('common.Comment')}}</el-button>
        <!--<el-button @click="resetForm('ruleForm')">取消</el-button>-->
      </div>
    </el-form>
  </div>
</template>

<script>
  import axios from '../../axios/index'

  export default {
    name: "commentForm",
    props: ['articleId'],
    data() {
      return {
        ruleForm: {
          content: '',
        },
      }
    },
    created: function () {

    },
    methods: {
      submitForm() {
        let _this=this;
        // 用户登录校验
        var token = localStorage.getItem('loginToken');
        if (token === '' || token == null) {
          this.$message({
            title: _this.$t('message.warning'),
            message: _this.$t('message.login'),
            type: 'warning',
            showClose: true,
            offset:300,
            duration:3000,
            onClose: function () {
              _this.$store.commit('login_dialog');
            }
          });
        }else {
          var content=this.ruleForm.content;
          axios.post(this.$store.state.apiBasePath + '/comment/add',{
            "articleId":this.articleId,
            "content":content
          }).then(function (res) {
            if (res.data.code === 200) {
              _this.ruleForm.content='';
              _this.$message({
                title: _this.$t('message.Success'),
                message: _this.$t('message.CommentReview'),
                type: 'success',
                showClose: true,
                offset:300,
                duration:3000,
              });
            }else {
              _this.$message({
                title: _this.$t('message.Error'),
                message: res.data.msg,
                type: 'error',
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          });
        }
      }
    }
  }


</script>

<style scoped>
  .comment-form {
    /*border-bottom: #ddd 0.018519rem solid;*/
    padding: 15px 0 30px 0;
    margin: 15px auto;
    width: 100%;
  }

  @media screen and (max-device-width: 1024px) {
    .comment-form {width: auto}



  }
</style>



// WEBPACK FOOTER //
// src/components/comment/commentForm.vue